module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_sukagawa-e565180f86b4788cfdee503a843296db.jpg";